import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useMsal } from '@azure/msal-react';
import { InteractionRequiredAuthError, InteractionStatus } from '@azure/msal-browser';
import { initMFE } from '../../../common/js/shell/index';
import Debug from '../../../common/js/utils/Debug';
import PageSpinner from '../../../common/js/components/PageSpinner';
import { ThemeProvider } from '@veneer/core';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import Loadable from 'react-loadable';
import { LoadingComponent } from '../../../common/js/components/LoadingComponent';
import Config from '../../../common/js/utils/Config';
import { initPendo } from '../../../common/js/utils/analyticsHelper';
import { loginRequest } from '../../../common/js/utils/msalConfig';
import { setAdminxUser } from '../../../api/reducers/authReducer';
import AccountLinked from '../steps/AccountLinked';
import Session from '../../../common/js/utils/Session';
import CookieConsent from '../../../common/js/components/CookieConsent';
import { allowSelfSignup } from '../../../common/js/utils/CommonUtils';
import { getSystem } from '../../../common/js/utils/palette';
import AppHeader from 'app/signUp/js/common/AppHeader';
import CompanyPreviewLayout from '../components/CompanyPreviewLayout';
import SelfSignUpLayout from '../components/SelfSignUpLayout';
import { Toasts } from '../components/Toasts';

/**
 * 1. newLoginOC
 * 2. signup?loginType=oc&code=onecloud_signup&email=abc@test.com&oc_get_started=true
 * 3. signup/company-create
 */

// Get started page - before user login
const GetStarted = Loadable({
  loader: () => import(/* webpackChunkName: "GetStarted" */ '../steps/GetStarted'),
  loading: LoadingComponent,
});
// new signup design flow
const CompanyInformationPage = Loadable({
  loader: () => import(/*  webpackChunkName: "CompanyInformation" */ '../../../signUp/js/pages/CompanyInformation'),
  loading: LoadingComponent,
});

const AdminxOnboard = () => {
  const [loading, setLoading] = useState(true);
  const [dui_token_e, setDui_Token] = useState(Session.getToken());
  let { instance, inProgress, accounts } = useMsal();
  const dispatch = useDispatch();
  const UseMsal = localStorage.getItem('useMsal');
  let theme = {
    mode: 'light',
    selectedColor: 'default',
  };
  let customSystem;
  if (Config.get('theme')) {
    //E.g: {"selectedColor":"wex","mode":"contrast"}
    let _themeOverride = Config.get('theme');
    if (_themeOverride.mode) {
      theme.mode = _themeOverride.mode;
    }
    if (_themeOverride.selectedColor) {
      theme.selectedColor = _themeOverride.selectedColor;
    }
    customSystem = getSystem(theme.mode, theme.selectedColor);
  }

  if (Config.get('demo')) {
    localStorage.setItem(
      'dui_token_e',
      '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',
    );
  }

  useEffect(() => {
    init();
  }, []);

  const onHpidSignIn = () => {
    if (Config.get('isPendoReady')) {
      pendo.track('SelfSignupStarted', {
        loginType: 'HPID',
        ...(localStorage.getItem('selected_service') ? { service: localStorage.getItem('selected_service') } : {}),
      });
    }
    localStorage.setItem('login_method', 'hpid');
    sessionStorage.setItem('loginType', 'hpid');
    window.location = Config.getLoginUrl('hpid');
  };

  useEffect(() => {
    if (inProgress === InteractionStatus.None && UseMsal) {
      var _config = {
        scopes: [...loginRequest.scopes],
        account: accounts[0] || localStorage.getItem('adminx__accountId'),
      };
      instance
        .acquireTokenSilent(_config)
        .then((response) => {
          // Required scope token is available.
          dispatch(setAdminxUser({ type: 'aadInfo', data: response.account }));
          Session.setAADToken(response.accessToken);
          Debug.log('Token Exist');
        })
        .catch((error) => {
          Debug.log(error.message);
          if (error instanceof InteractionRequiredAuthError) {
            instance
              .acquireTokenPopup(loginRequest)
              .then((response) => {
                dispatch(setAdminxUser({ type: 'aadInfo', data: response.account }));
                Session.setAADToken(response.accessToken);
              })
              .catch((error) => {
                Debug.log('Error while AAD login for ');
                Debug.log(error);
              });
          }
        });
    }
  }, [instance, accounts, inProgress]);

  const init = () => {
    Session.generateSessionId();
    initMFE()
      .then(() => {
        Session.setAADToken();
        Session.setTpToken();
        // check if token is present and exp time is greater than current time. Remove if it is expired.
        if (!Config.get('demo')) {
          if (Session.getTpToken()) {
            Session.removeTokenIfExpired();
          }
        }
        initPendo();
        setLoading(false);
      })
      .catch((e) => {
        console.log('Init Exception:' + e);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const isAuthenticated = Config.get('demo') ? false : dui_token_e;
  const isPermitted = allowSelfSignup();

  // Helper function to wrap components with appropriate layout
  const withLayout = (Component, useCompanyPreviewLayout = false) => {
    const LayoutWrapper = useCompanyPreviewLayout ? CompanyPreviewLayout : SelfSignUpLayout;
    return (props) => (
      <LayoutWrapper>
        <Component {...props} />
      </LayoutWrapper>
    );
  };

  return (
    <ThemeProvider mode={theme.mode || 'light'} density='high' customSystem={customSystem}>
      <div className='dui-adminx'>
        {loading ? (
          <PageSpinner />
        ) : (
          <Router basename={Config.get('routeBase')}>
            <React.Fragment>
              <Route path={'/*'} render={(props) => <AppHeader {...props} />} />
              <Switch>
                {[
                  ...(isPermitted
                    ? [
                        <Route
                          exact
                          path='/company-create'
                          component={withLayout(CompanyInformationPage, true)}
                          key='CreateCompanyContainer'
                        />,
                        <Route exact path='/account-linked' component={withLayout(AccountLinked, true)} key='AccountLinked' />,
                      ]
                    : []),
                  ...(isAuthenticated
                    ? [<Route exact path='/' component={withLayout(AccountLinked)} key='AccountLinkedAuth' />]
                    : [
                        <Route
                          exact
                          path='/'
                          key='GetStarted'
                          render={(props) => (
                            <SelfSignUpLayout>
                              <GetStarted {...props} updateToken={setDui_Token} onHpidSignIn={onHpidSignIn} />
                            </SelfSignUpLayout>
                          )}
                        />,
                        <Route
                          exact
                          path='/get-started'
                          key='GetStartedAlt'
                          render={(props) => (
                            <SelfSignUpLayout>
                              <GetStarted {...props} updateToken={setDui_Token} onHpidSignIn={onHpidSignIn} />
                            </SelfSignUpLayout>
                          )}
                        />,
                      ]),
                  <Route
                    path='/*'
                    key='DefaultRoute'
                    render={() => {
                      console.log('No route match found!');
                      return <Redirect to={{ pathname: '/' }} />;
                    }}
                  />,
                ]}
              </Switch>
            </React.Fragment>
          </Router>
        )}
      </div>
      {CookieConsent(Config.get('cookieConsentUrl'))}
      <Toasts />
    </ThemeProvider>
  );
};

export default AdminxOnboard;
